import { ArticleLayout, useSlug } from "../components/ArticleLayout";
import { CASE_STUDIES } from "../lib/data";

export default function CaseStudyDetail() {
  const slug = useSlug();
  const item = CASE_STUDIES.find((c) => c.slug === slug);
  return <ArticleLayout item={item} kicker="Client Story" backTo="/case-studies" backLabel="All client stories" />;
}
